module.exports = __webpack_public_path__ + "static/img/head.88a6d15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head.jpg
// module id = C4k+
// module chunks = 81